import { useCallback } from "react";
import { useSdkContext } from "~/components/contexts";
export const useBookmarkButton = () => {
  const {
    bookmark
  } = useSdkContext();
  const bindBookmarkButton = useCallback(({
    entityId,
    trackings
  }, onClick) => {
    const isBookmarked = bookmark.check({
      entityId
    });
    const props = {
      isBookmarked,
      onClick: action => {
        bookmark.update({
          action,
          entityId,
          trackings
        });
        onClick === null || onClick === void 0 || onClick();
      }
    };
    return props;
  }, [bookmark]);
  return {
    bindBookmarkButton
  };
};